/**
 * Enum of all possible content types
 */
export enum ContentType {
    WoltersKluwer = 'WOLTERS_KLUWER',
    External = 'EXTERNAL',
    Own = 'OWN',
}

/**
 * Represents the base class all Section content must inherit from.
 * Mainly used to distinguish different Content in Class-Validator.
 */
export interface Content {
    /**
     * Selected content type enum value
     */
    type: ContentType;
}

export function isContent(value: unknown): value is Content {
    return typeof value === 'object' && value !== null && 'type' in value
      && Object.values(ContentType).includes(value['type']);
}
